import styled from 'styled-components';

export const FormRow = styled.div<{ grid?: string }>`
  display: grid;
  grid-template-columns: ${props => props.grid || '1fr 1fr'};
  gap: 1rem;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 1.25rem;
  }
`;

export default FormRow;
